import React, { useCallback, useEffect } from "react";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import * as jose from "jose";

const signingKey = import.meta.env.VITE_SIGNING_KEY;
const urlTokenDuration = import.meta.env.VITE_URL_TOKEN_DURATION || "2m";

export const ChanelEntryPage = () => {
  // JWT形式のトークンを生成
  const generateAccessToken = useCallback(async () => {
    const encodedSecret = new TextEncoder().encode(signingKey);
    return await new jose.SignJWT({ access_granted: true })
      .setProtectedHeader({ alg: "HS256" })
      .setExpirationTime(urlTokenDuration)
      .setIssuedAt()
      .sign(encodedSecret);
  }, []);

  // 既存のクエリパラメーターを保持してtopページに遷移
  const navigateToTop = useCallback(async () => {
    const accessToken = await generateAccessToken();
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set("access_token", accessToken);
    window.location.href = `/top?${currentParams.toString()}`;
  }, [generateAccessToken]);

  // レンダリング時に自動でtopページに遷移
  useEffect(() => {
    navigateToTop();
  }, [navigateToTop]);

  return (
    <AnimatedPageTransition>
      <div className="bg-white" style={{ height: window.innerHeight }}>
        {/* 真っ白な画面 */}
      </div>
    </AnimatedPageTransition>
  );
};
